import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { KpiCard } from '../interfaces/dashboard.component';

@Component({
  selector: 'app-dashboard-kpi-card',
  standalone: false,
  templateUrl: './dashboard-kpi-card.html',
  styleUrl: './dashboard-kpi-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardKpiCardComponent {
  @Input() card?: KpiCard;
  @Input() loading = false;
  @Input() billingPeriod: 'today' | 'week' | 'month' = 'week';
  @Input() storagePeriod: 'today' | 'week' | 'month' = 'week';

  @Output() billingPeriodChange = new EventEmitter<'today' | 'week' | 'month'>();
  @Output() storagePeriodChange = new EventEmitter<'today' | 'week' | 'month'>();

  onBillingChange(value: string): void {
    this.billingPeriodChange.emit(value as 'today' | 'week' | 'month');
  }

  onStorageChange(value: string): void {
    this.storagePeriodChange.emit(value as 'today' | 'week' | 'month');
  }
}
